import React from 'react';
import { InfoSection, Pricing } from '../../components';
import { homeObjThree} from './Data';
import { Col, Divider, Row } from 'antd';
import InfoSectionCarrusel  from '../../components/InfoSection/InfoSectionCarrusel'; 
import LogoScroller from '../../components/LogoScroller'


const Home = () => {
    return (
        <>
         
            <InfoSectionCarrusel  />
            <InfoSection {...homeObjThree} />
            <LogoScroller/>
            <Pricing />
            {/**
             * 
             * <InfoSection {...homeObjTwo} />
            
            <InfoSection {...homeObjFour} />
             */}
        </>
    )
}

export default Home;